'use client';

import { simpleHero } from '@stereoagency/sanity-schema';
import { SimpleHero as UISimpleHero } from '@stereoagency/ui';
import { SimpleBlockContent } from '../sanity/client';

type Props = typeof simpleHero.schema.simpleHero;

export default function SimpleHero({ title, description }: Props) {
  if (!title) {
    return null;
  }

  return (
    <UISimpleHero
      title={title}
      description={
        description ? <SimpleBlockContent value={description} /> : null
      }
    />
  );
}
